import React, { useState, useEffect, useRef } from 'react'
import { View, StyleSheet } from 'react-native'
import StyledTextInput from '../../components/StyledTextInput'

export default function ClientSearchBox(props) {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);

  const handleSearch = (text) => {
    setValue(text);
    if (props.onSearch) {
      props.onSearch(text);
    }
  };

  return (
    <View style={props.style}>
      <StyledTextInput
        ref={inputRef}
        value={value}
        onChangeText={handleSearch}
        clearButtonMode="while-editing"
        autoCapitalize="none"
        autoCorrect={false}
        spellCheck={false}
        autoCompleteType="off"
      />
    </View>
  )
}
